import { Outlet } from 'react-router-dom';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { useAuthStore } from '@/stores/authStore';
import { useLanguageStore } from '@/stores/languageStore';

const Layout: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { user, isAuthenticated } = useAuthStore();
  const { isRTL } = useLanguageStore();
  
  return (
    <Flex h="100vh">
      {isAuthenticated && (
        <Sidebar 
          isOpen={isOpen} 
          onClose={onClose} 
          role={user?.role} 
        />
      )}
      
      <Box 
        flexGrow={1} 
        overflow="auto"
        ml={!isRTL ? { base: 0, md: 60 } : 0} // Left margin for LTR languages
        mr={isRTL ? { base: 0, md: 60 } : 0}  // Right margin for RTL languages
        mt={2}
        transition="margin 0.3s"
      >
        <Header onOpenSidebar={onOpen} />
        <Box 
          as="main" 
          p={4} 
          maxW="1600px" 
          mx="auto" 
          minH="calc(100vh - 140px)"
        >
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </Flex>
  );
};

export default Layout;